/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getServicesList: (params) => {
    return axios.get(API_ENDPOINTS.GET_SERVICE_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json",
        "x-tenant-slug":"default" },
      params,
    });
  },
  getServicebyid: (id) => {
    //console.log('url-->',API_ENDPOINTS.GET_SERVICE_DETAILS_BY_ID + "/" + id);
    return axios.get(API_ENDPOINTS.GET_SERVICE_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json",
        "x-tenant-slug":"default" },
    });
  },
  addservices: (data) => {
    return axios.post(API_ENDPOINTS.ADD_SERVICES, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
        "x-tenant-slug":"default",
      },
    });
  },
  updateService: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_SERVICE_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
        "x-tenant-slug":"default",
      },
    });
  },
  deleteServices: (id) => {
    //console.log('url-->',API_ENDPOINTS.DELETE_SERVICE_BY_ID + "/" + id);
    return axios.delete(API_ENDPOINTS.DELETE_SERVICE_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json",
        "x-tenant-slug":"default" },
    });
  },
};
